<template>
  <component :is="animationComponent" v-if="activeHoliday && animationComponent && shouldShowAnimation" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      holidayAnimation: 'holidayAnimation',
    }),
    activeHoliday() {
      return this.$holiday?.getActive()
    },
    shouldShowAnimation() {
      // Check if animation is enabled for this holiday and if the user has toggled it on
      return this.activeHoliday?.animation?.enabled && this.holidayAnimation
    },
    animationComponent() {
      if (!this.activeHoliday?.animation?.component) {
        return null
      }

      // Dynamically import the animation component based on holiday ID
      const holidayId = this.activeHoliday.id

      try {
        return () => import(`@/components/holiday/${holidayId}/Animation.vue`)
      } catch (error) {
        console.warn(`Holiday animation component not found for: ${holidayId}`, error)
        return null
      }
    },
  },
}
</script>
